const mapSelection = (selection, winInfo) => ({
  id: selection.RoundId,
  roundId: selection.RoundId,
  name: selection.GameName,
  numbers: selection.Numbers?.[0]?.length ? selection.Numbers[0] : null,
  winNumbers: winInfo?.Result?.Numbers?.[0],
  rawNumbers: selection.Numbers?.[0]?.length ? selection.Numbers[0].join(",") : null,
  marketName: `${selection.MarketName}: ${selection.SelectionName}`,
  jackpotWin: winInfo?.JackpotWin,
  jackpotName: winInfo?.JackpotName,
  drawDate: selection.DrawDate,

  price: selection.Odds,
  amount: selection.BetAmount,
  possibleWin: selection.PossibleWin,
});

export const mapOmniplaySelections = ticket => {
  const { casinoInfo } = ticket;

  return casinoInfo.BetMultiplyInfo.map((selection) =>
    mapSelection(
      selection,
      casinoInfo.WinMultiplyInfo?.find(
        info => info.AdditionalInfo?.BetWinLinkId === selection.ProviderRoundId
      )
    )
  );
};
